import { render, staticRenderFns } from "./PersonalizedImage.vue?vue&type=template&id=b296b90e&scoped=true"
import script from "./PersonalizedImage.vue?vue&type=script&lang=js"
export * from "./PersonalizedImage.vue?vue&type=script&lang=js"
import style0 from "./PersonalizedImage.vue?vue&type=style&index=0&id=b296b90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b296b90e",
  null
  
)

export default component.exports